import { IDateRangeSelection, PeriodRangeType } from 'src/app/models/date';
import { IAmount } from './portfolioNetAsset';
import { IPortfolio, IPortfolioOption } from "./portfolios";
import { INameValueFilter } from "./filter";

export enum ReportDocumentType {
    TaxSummaryReport = '10',
    ManagementAccountsReport = '14',
    GeneralLedgerReport = '15',
    InvestmentReportByClassification = '17',
    ApsReport = '18',
    InvestorListReport = '27',
    AllHoldingsReport = '28',
    CapitalMovementsReport = '29',
    PortfolioPerformanceReport = '30',
    MemberListReport = '31'
}

export enum AllHoldingsReportType {
    ManagerAndSecurity = '0',
    PortfolioAndSecurity = '1',
    ConsolidatedFUM = '2'
}

export interface IReportsSuccessfulSelector {
    isReportSuccessful: boolean;
    reportSuccessfulText: string;
}

export interface IRunReportRequestObject {
  documentType: ReportDocumentType;
  portfolio?: IPortfolio | IPortfolioOption;
  client?: INameValueFilter;
  allHoldingsReportType?: AllHoldingsReportType;
  period?: IDateRangeSelection;
  sections?: IReportSections;
  allSelected?: boolean;
}

export interface IReportSections {
  valuation: boolean;
  portfoliosummary: boolean;
  statementsummary: boolean;
  transaction: boolean;
  performance: boolean;
}

export interface IInvestmentReportDisplaySections {
  DisplayValuationSection: boolean;
  DisplayPortfolioSummarySection: boolean;
  DisplayStatementSummarySection: boolean;
  DisplayTransactionSection: boolean;
  DisplayPerformanceSection: boolean;
  DownloadOnly: boolean;
}

export interface ICreateReportRequestObject {
    reportType: string;
    parameters : IReportOptionParameters;
}

export interface IReportOptionParameters {
    startDate : string;
    periodType: PeriodRangeType;
    endDate: string;
    allHoldingsReportType: AllHoldingsReportType;
    portfolioIds: number[];
}

export interface IDownloadReportRequestObject {
    documentId: number;
}

export interface IRunReportResponseObject {
    fileType: string;
    fileName: string;
    fileStream: any;
}

export interface IReportRequestData {
    id: number;
    entityName: string;
    reportName: string;
    period: string;
    createdAt: Date;
    myDocumentId: number;
    status: number;
    errorMessage: string;
}

export enum ReportRequestStatus
{
    Queued = 0,
    Processsing = 1,
    Completed = 2,
    Failed = 3
}

export interface IReportRequest {
    entity: string;
    reportName: string;
    period: any;
    createdAt: Date;
    myDocumentId: number;
    status: number;
    errorMessage: string;
}

export interface IReportRequestDataResult {
    reportRequestData: IReportRequestData[];
}

export interface AggregatedHoldingsReportModel {
    investorCount: number,
    positions: PositionViewModel[],
    positionsTotal: IAmount
}

export interface PositionViewModel {
    securityId: number,
    securityName: string,
    investorCount: number,
    amount: IAmount
}

export interface Period {
  title: string;
  value: PeriodRangeType;
}

export const PERIODS: Period[] = [
  {
    title: 'Day',
    value: PeriodRangeType.day,
  },
  {
    title: 'Week To Date',
    value: PeriodRangeType.weekToDate,
  },
  {
    title: 'Month To Date',
    value: PeriodRangeType.monthToDate,
  },
  {
    title: 'Quarter To Date',
    value: PeriodRangeType.quarterToDate,
  },
  {
    title: 'Six Months To Date',
    value: PeriodRangeType.sixMonthsToDate,
  },
  {
    title: 'One Year To Date',
    value: PeriodRangeType.yearToDate,
  },
  {
    title: 'Custom',
    value: PeriodRangeType.custom,
  },
];
